// extracted by mini-css-extract-plugin
export default {"container":"TopMenuForSearch_container__ULgMb"};